const url = process.env.REACT_APP_HR_BEE_API_PATH


export const documentsUrl = url + '/images-files/';